<div class="content-column">
    <div style="position: absolute; z-index: 10; top: 5px; right: 0;">
        <mat-dialog-actions align="end" class="p-0" style="min-height: 0;">
            <mat-icon class="pt-3 pr-5" mat-dialog-close style="color: #fff; cursor: pointer; font-size: 32px; margin-right: 10px;">highlight_off</mat-icon>
        </mat-dialog-actions>
    </div>
    <img style=" width: 100%; height: 100%;" [src]="imageView | securityDom" alt="">
</div>

